// Keep this as it runs before anything else
// We need to define window.dataLayer in order for events to be buffered
// before GTM consent is given. Otherwise these events will be lost...
export default defineNuxtPlugin(() => {
  if (typeof window === "undefined") return
  window.dataLayer = window.dataLayer || []
  // DEFAULT: deny everything
  window.dataLayer.push({
    event: "default_consent",
    ad_storage: "denied",
    analytics_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    personalization_storage: "denied",
    functionality_storage: "denied",
    security_storage: "denied",
  })
})
